import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/wh-support-docs/wh-support-docs/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`This page contains system requirements information for Merative Integrated Care.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Supported Browsers</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Accessibility</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Support Policy Notes</AnchorLink>
    </AnchorLinks>
    <h2>{`Supported Browsers`}</h2>
    <p>{`Merative Integrated Care is a SaaS product and the only software requirement is a supported browser.`}</p>
    <p>{`Merative Integrated Care supports the following browsers:`}</p>
    <ul>
      <li parentName="ul">{`Apple Safari current (non-beta)`}
        <ul parentName="li">
          <li parentName="ul">{`Safari is the supported browser for iOS mobile devices.`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Google Chrome current (non-beta)`}
        <ul parentName="li">
          <li parentName="ul">{`Chrome is the supported browser for Android mobile devices.`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Microsoft Edge current (non-beta)`}</li>
      <li parentName="ul">{`Mozilla Firefox current (non-beta)`}</li>
    </ul>
    <p>{`Merative Integrated Care Reporting supports the following browsers:`}</p>
    <ul>
      <li parentName="ul">{`Apple Safari current (non-beta)`}</li>
      <li parentName="ul">{`Mozilla Firefox ESR 91`}</li>
      <li parentName="ul">{`Google Chrome current (non-beta)`}</li>
      <li parentName="ul">{`Microsoft Edge Chromium current (non-beta)`}</li>
    </ul>
    <h2>{`Accessibility`}</h2>
    <p>{`Merative Integrated Care supports the Freedom Scientific JAWS screen reader 19 and future fix packs. The combination of Jaws 19 and Mozilla Firefox is the only certified screen reader and browser combination.`}</p>
    <h2>{`Support Policy Notes`}</h2>
    <p>{`Supported browsers are tested for compatibility. Always use one of the browsers listed here as other browsers are not tested. If you use a browser that is not listed and encounter an issue that requires support, you might be required to test and reproduce the issue with a recommended browser to receive further support.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      